export default "__VITE_ASSET__D_q9i6cy__"